import React, { useState, useEffect } from "react";
// import { useSnackbar } from 'notistack';
import { toast } from 'react-toastify';
import ArticleService from "../services/article";
import { useParams, useLocation } from "react-router-dom";

const LessonArticlePage = () => {
  const { id } = useParams(); // 使用 id 作为参数名
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchArticle = async () => {
      if (!id) return;
      
      try {
        setLoading(true);
        const result = await ArticleService.getLessonArticle(id);
        if (mounted) {
          setArticle(result.content);
        }
      } catch (error) {
        if (mounted) {
          toast.error('获取文章失败');
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchArticle();

    // 清理函数
    return () => {
      mounted = false;
    };
  }, [id]);

  if (loading) {
    return <div>加载中...</div>;
  }

  return (
    <div style={{ padding: '0 30px 30px 30px' }}>
      {article && (
        <>
          <h1>{article.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: article.content }} />
        </>
      )}
    </div>
  );
};

export default LessonArticlePage;